import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export default function WarningIcon(props: SvgIconProps): JSX.Element {
  const defaultColor = "warning";
  const color = props.color || defaultColor;
  return (
      <SvgIcon
          {...props}
          color={color}
          xmlns="http://www.w3.org/2000/svg"
          x={0}
          y={0}
          viewBox="0 0 24 24"
          xmlSpace="preserve"
          enableBackground="new 0 0 24 24"
          titleAccess="Warning"
      >
        <circle cx="12" cy="12" r="11" fill="#D87A1C" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13 6C13 5.44772 12.5523 5 12 5C11.4477 5 11 5.44772 11 6V14C11 14.5523 11.4477 15 12 15C12.5523 15 13 14.5523 13 14V6ZM13.25 18.25C13.25 17.5596 12.6904 17 12 17C11.3096 17 10.75 17.5596 10.75 18.25V18.2924C10.75 18.9828 11.3096 19.5424 12 19.5424C12.6904 19.5424 13.25 18.9828 13.25 18.2924V18.25Z"
            fill="white"
        />
      </SvgIcon>
  )};